import { registerTour } from "../tourRegistry";

function getSteps() {
  const totalSteps = 4;
  const stepCounter = (n) => `Step ${n} of ${totalSteps}`;

  return [
    {
      id: 'consol-page',
      title: `Consolidation <span class="t3-shepherd-step-count">${stepCounter(1)}</span>`,
      text: 'Consolidation lets a parent organization combine financial data from child organizations into unified reports. This page configures how your organization\'s funds and accounts map to the parent.',
      attachTo: { element: '[data-tour="consol-page"]', on: 'bottom' },
      buttons: [
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'consol-status',
      title: `Status <span class="t3-shepherd-step-count">${stepCounter(2)}</span>`,
      text: 'The status card shows whether consolidation is active and which parent organization you\'re connected to.',
      attachTo: { element: '[data-tour="consol-status"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'consol-tabs',
      title: `Mapping Tabs <span class="t3-shepherd-step-count">${stepCounter(3)}</span>`,
      text: 'Use the Fund Mapping tab to map your funds to the parent organization\'s funds, and the Account Mapping tab for accounts. Both must be configured for consolidation to work correctly. Intercompany Pairs handles balance-sheet netting, and Linked Accounts (when enabled) shows inter-entity transfer links managed by the parent.',
      attachTo: { element: '[data-tour="consol-tabs"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'consol-mapping',
      title: `Mapping Table <span class="t3-shepherd-step-count">${stepCounter(4)}</span>`,
      text: 'For each of your funds or accounts, select the corresponding item in the parent organization. Unmapped items won\'t appear in the parent\'s consolidated reports.',
      attachTo: { element: '[data-tour="consol-mapping"]', on: 'top' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Done',
          classes: 't3-shepherd-next-btn',
          action() { this.complete(); },
        },
      ],
    },
  ];
}

registerTour({
  id: 'consolidation',
  pathPattern: '/foundation/consolidation',
  getSteps,
  label: 'Consolidation Mapping Tour',
});
